import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    padding: '16px 24px',
  },
});

export default useStyles;
